import { render, staticRenderFns } from "./judgeCard.vue?vue&type=template&id=5af47cbe&scoped=true&"
import script from "./judgeCard.vue?vue&type=script&lang=js&"
export * from "./judgeCard.vue?vue&type=script&lang=js&"
import style0 from "./judgeCard.vue?vue&type=style&index=0&id=5af47cbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af47cbe",
  null
  
)

export default component.exports